import React, { useEffect, useState } from 'react';
import '../styles/components/Navbar.scss';
import { supabase } from '../helpers/Supabase';

interface NavbarProps {
    toggleSidenav: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ toggleSidenav }) => {
    const [userName, setUserName] = useState('');
    const [logoUrl, setLogoUrl] = useState('');
    const [userType, setUserType] = useState<'client' | 'delegate'>('client');

    useEffect(() => {
        const fetchUserDetails = async () => {
            const {
                data: { user },
            } = await supabase.auth.getUser();

            if (user) {
                // First check if user is a delegate
                const { data: clientDelegate } = await supabase
                    .from('client_delegates')
                    .select('*, clients(name, logo_url)')
                    .eq('email', user.email)
                    .eq('is_active', true)
                    .single();

                const { data: storeDelegate } = await supabase
                    .from('store_delegates')
                    .select('*, stores(store_name, clients(name, logo_url))')
                    .eq('email', user.email)
                    .eq('is_active', true)
                    .single();

                if (clientDelegate) {
                    // User is a client delegate
                    setUserType('delegate');
                    setUserName(clientDelegate.name || user.email || 'Delegate');
                    setLogoUrl(clientDelegate.clients?.logo_url || '');
                } else if (storeDelegate) {
                    // User is a store delegate
                    setUserType('delegate');
                    setUserName(storeDelegate.name || user.email || 'Delegate');
                    setLogoUrl(storeDelegate.stores?.clients?.logo_url || '');
                } else {
                    // User is a regular client
                    setUserType('client');
                    const { data: userRow, error: userFetchErr } = await supabase
                        .from('users')
                        .select('client_id')
                        .eq('auth_user_id', user.id)
                        .maybeSingle();

                    if (!userFetchErr && userRow?.client_id) {
                        const { data: client, error: clientFetchErr } = await supabase
                            .from('clients')
                            .select('name, logo_url')
                            .eq('id', userRow.client_id)
                            .single();

                        if (!clientFetchErr && client) {
                            setUserName(client.name);
                            setLogoUrl(client.logo_url);
                        }
                    }
                }
            }
        };

        fetchUserDetails();
    }, []);

    return (
        <nav className="navbar">
            <div className="hamburger-menu" onClick={toggleSidenav}>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div className="navbar-right">
                {logoUrl && (
                    <img
                        src={logoUrl}
                        alt="Client Logo"
                        className="client-logo"
                        style={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '10px' }}
                    />
                )}
                <span className="greeting">
                    {userName || 'User'}
                    {userType === 'delegate' && <span className="delegate-badge">Delegate</span>}
                </span>
            </div>
        </nav>
    );
};

export default Navbar;